import { Button, Card } from 'antd';
import React from 'react';
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';
import config from '../../config';

const AddonPlans = ({journeyType, addons, loading, setSelectedAddon, selectedAddon, setSelectedAddonReturn, selectedAddonReturn }) => {

    const convertCurrency = useCurrencyConverter();
    const { currency } = useCurrency();

    const handleClick = (addon) => {
        // If addon already selected, remove it, otherwise add it
        if (selectedAddon?.some(a => a.id === addon.id)) {
            setSelectedAddon(selectedAddon.filter(a => a.id !== addon.id));
        } else {
            setSelectedAddon([...(selectedAddon || []), addon]);
        }
    }

    const handleClickReturn = (addon) => {
        // If addon already selected, remove it, otherwise add it
        if (selectedAddonReturn?.some(a => a.id === addon.id)) {
            setSelectedAddonReturn(selectedAddonReturn.filter(a => a.id !== addon.id));
        } else {
            setSelectedAddonReturn([...(selectedAddonReturn || []), addon]);
        }
    }

    return (
        <div className="vehicle-plans">
            <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                Select One Way Add-ons (Optional)
            </div>
            <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                {
                    addons?.map((addon) => {
                        return (
                            <Card
                                onClick={() => { handleClick(addon) }}
                                className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                hoverable
                                style={{
                                    width: 240,
                                    backgroundColor: '#E5E4E2',
                                    borderRadius: '8px',
                                    border: selectedAddon?.some(a => a.id === addon.id) ? '5px solid #00803e' : ''
                                }}
                                cover={<img alt="example" className='h-[138px]' style={{
                                    objectFit: 'contain'
                                }} src={`${config.API_URL}/${addon.picture}`} />}
                            >
                                <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                    {addon.name}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {currency} {convertCurrency(Math.ceil(addon.priceInPKR))}
                                </div>
                                <Button type='button' className='w-full mt-2' style={{
                                    backgroundColor: '#00803e',
                                    color: '#ffffff'
                                }}>Select</Button>
                            </Card>
                        )
                    })
                }
            </div>
            {
                loading &&
                'Loading...'
            }




            {journeyType == 'return' && <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                Select Return Add-ons (Optional)
            </div>}
            {journeyType == 'return' && <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                {
                    addons?.map((addon) => {
                        return (
                            <Card
                                onClick={() => { handleClickReturn(addon) }}
                                className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                hoverable
                                style={{
                                    width: 240,
                                    backgroundColor: '#E5E4E2',
                                    borderRadius: '8px',
                                    border: selectedAddonReturn?.some(a => a.id === addon.id) ? '5px solid #00803e' : ''
                                }}
                                cover={<img alt="example" className='h-[138px]' style={{
                                    objectFit: 'contain'
                                }} src={`${config.API_URL}/${addon.picture}`} />}
                            >
                                <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                    {addon.name}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {currency} {convertCurrency(Math.ceil(addon.priceInPKR))}
                                </div>
                                <Button type='button' className='w-full mt-2' style={{
                                    backgroundColor: '#00803e',
                                    color: '#ffffff'
                                }}>Select</Button>
                            </Card>
                        )
                    })
                }
            </div>}
            {
                journeyType == 'return' && loading &&
                'Loading...'
            }
        </div>
    );
};

export default AddonPlans;
